/**
 * Vybraný riadok tabuľky (KOLO 180, návrh D): modrý podklad, 4 px modrý
 * pruh a tenký rám — vidno ho aj z diaľky a nemýli sa s červenou chybou.
 * Rám je vnútorný tieň (ako čiara ťahania z KOLA 176), `outline` by pri
 * `border-collapse` prekryl susedné riadky. Od KOLA 241 ho zdieľa tabuľka
 * dielcov nábytku aj tabuľka tovaru.
 */
export const VYBRANY_RIADOK =
  "border-l-vyber bg-vyber-podklad hover:bg-vyber-podklad [&_td]:shadow-[inset_0_1px_0_0_hsl(var(--vyber)),inset_0_-1px_0_0_hsl(var(--vyber))]";
